
import React, { Component, Fragment } from 'react'
import CenterElement from '../../activity/activityComponent/CenterElement'
import DragItemUI from '../../ddTxtImg/ui/DragItemUI'


class SortStoryDragItemUI extends DragItemUI {




    // getDragItemUI = (dragItem) => {
    //     return (
    //         <div style={{ width: "50px", height: "50px", border: "solid 1px black", margin: "10px", display: "inline-block", borderRadius: "5px" }}>
           

    //             <table style={{ width: "100%", height: "100%" }}>
    //                 <tbody>
    //                     <tr>
    //                         <td style={{ width: "100%", height: "100%", verticalAlign: "middle", textAlign: "center" }}>
    //                             <span ref={(el) => this.itemToDrag = el} style={{}}
    //                                 dangerouslySetInnerHTML={{ __html: dragItem.dragIndex + 1 }}
    //                             ></span>
    //                         </td>
    //                     </tr>
    //                 </tbody>
    //             </table>
    //         </div>
    //     )
    // }

}

export default SortStoryDragItemUI